import { splitBibliographyUrls, getBibliographyUrlStyle } from "@/lib/bibliographyUrlStyle";

// Shared by current sections, older blog records, and the settings preview.
export default function BibliographyRef({ text, enabled = true, styleId = "subtle" }) {
  const style = getBibliographyUrlStyle(styleId);
  return splitBibliographyUrls(String(text ?? "")).map((part, index) => {
    if (part.type === "text" || !enabled) return <span key={index}>{part.value}</span>;
    const label = style.displayAs === "bracket" ? "[link]"
      : style.displayAs === "icon" ? "↗" : part.value;
    return (
      <a key={index} href={part.href} target="_blank" rel="noopener noreferrer"
         className={style.anchorClass} title={style.displayAs ? part.value : undefined}
         data-testid={`bibliography-url-${index}`}>
        {label}
      </a>
    );
  });
}
